<template>
  <Menu
    class="app-menu"
    rounded="0"
    :tabindex="tabindex"
    :close-on-click="true"
    :close-on-content-click="false"
    :max-height="300"
    :min-width="'25rem'"
    :attach="'#locations_filter_menu_list'"
  >
    <template v-slot:menu-btn="{ on, attrs }">
      <v-toolbar-title v-on="on" class="app-menu-btn filter-locations-btn filter--btn">
        <FIcon :name="'filter-locations'" size="1.4rem" class="location-icon" />
        <span class="btn-title"> {{ locationTitle }} </span>
        <span class="menu-arrow" :class="attrs['aria-expanded'] !== 'false' ? 'app-menu-active' : ''"></span>
      </v-toolbar-title>
    </template>
    <template #menu-list>
      <div class="menu-list-container locations-filter-menu">
        <v-progress-circular :value="20" indeterminate v-if="isLoading"></v-progress-circular>
        <v-list class="locations-single-list">
          <v-list-item>
            <v-list-item-title>
              <label for="locations_search_input" class="search-input-container">
                <input
                  type="text"
                  id="locations_search_input"
                  ref="locationsSearchRef"
                  class="search-input"
                  v-model.trim="query"
                  autocomplete="off"
                  :placeholder="$t('locations_search_placeholder')"
                />
                <FIcon name="close" color="#06c1ed" size="1rem" v-if="!!query" @click.native="handleOnRrSetSearch" />
              </label>
            </v-list-item-title>
          </v-list-item>

          <div class="divider" />

          <div v-if="list.length === 0">
            <v-list-item-title class="px-4 py-2">
              {{ $t("no_locations") }}
            </v-list-item-title>
          </div>

          <v-radio-group v-model="selectedLocation" :value="selectedLocation" :hide-details="true">
            <v-list-item v-for="(location, index) in list" :key="`col-filter-id-${index}`">
              <v-list-item-title>
                <v-radio
                  ref="filter_column"
                  class="filter-checkbox"
                  :disabled="!isLocations"
                  :ripple="false"
                  :hide-details="true"
                  :label="location.name"
                  :value="location"
                />
              </v-list-item-title>
            </v-list-item>
          </v-radio-group>
        </v-list>
      </div>
    </template>
  </Menu>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SingleFiltersLocations",

  data() {
    return {
      isLoading: true,
      toggleAllFilters: true,
      selectedLocation: null,
      query: "",
      list: [],
      original: [],
    };
  },

  props: {
    isLocations: {
      type: Boolean,
      default: true,
    },

    tabindex: {
      type: String,
      default: "1",
    },
  },

  beforeMount() {
    this.getBusinessLocations();
  },

  computed: {
    ...mapGetters({
      locationsList: "Business/locationsList",
      filter: "App/filter",
    }),

    locationTitle() {
      return !this.selectedLocation ? this.$t("select_locations") : this.selectedLocation?.name;
    },

    locations() {
      return this.filter?.locations;
    },
  },

  watch: {
    selectedLocation: {
      immediate: true,
      deep: true,
      handler(location) {
        if (!!location && !this.isLoading) {
          this.filter.locations.map((current) => {
            current.selected = current.id === location.id;
          });

          this.filter.storeLocations();
          this.ordinal = window._.clone(this.filter.locations);
        }
      },
    },

    query: {
      immediate: true,
      deep: true,
      handler(value) {
        if (typeof value !== "string") {
          return;
        }

        let list = window._.clone(this.filter.locations);
        this.list = list.filter((item) => item?.name?.includes(value));
        this.$nextTick(() => {
          this.selectedLocation = this.filter.locations.find((item) => item.selected);
        });
      },
    },
  },

  methods: {
    /**
     * Get business locations if no locations saved
     * @return {void}
     */
    async getBusinessLocations() {
      this.filter.setLocations(this.locationsList);

      this.$nextTick(async () => {
        await this.setSelectedLocation();
        this.original = window._.clone(this.filter.locations);
        this.list = window._.clone(this.filter.locations);
        this.isLoading = false;
      });
    },

    /**
     * Select all locations
     * @return {void}
     */
    handleOnSelectAll(value) {
      this.locations.forEach((item, index) => (item.selected = value));
    },

    setSelectedLocation() {
      this.selectedLocation = this.locations.find((location) => location.selected);
    },

    /**
     * Handle to reset search
     * @return {void}
     */
    handleOnRrSetSearch() {
      this.query = "";
    },
  },
};
</script>
